import { HostListener, Injectable, NgZone } from '@angular/core';
import { FormioUtils as Utils } from 'angular-formio';
import { ButtonActionsService } from '@app/services/applyment/button-actions-service/button-actions.service';
import { PopUpApplymentService } from '@app/services/pop-up/pop-up-applyment.service';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { DialogComponent } from '@shared/components/dialog/dialog.component';
import { DialogPopupFormComponent } from '@shared/components/dialog/template/dialog-popup-form/dialog-popup-form.component';
import { filterResponse } from '@shared/utils/rxjs-operators';
import { isValidCPF, isIOSDevice } from '@shared/utils/util';
import { ReportService } from '@modules/client/services/report.service';
import { DialogPdfViewer } from '@shared/components/dialog/template/dialog-pdf-viewer/dialog-pdf-viewer.component';
import { GetStepsService } from '@modules/client/registration-steps/pages/registration-steps-page/services/get-steps.service';
import { ApplymentModel } from '@app/services/client-general-settings/applyment/applyment.model';
import { IugoService } from '@modules/client/services/iuguAfya/iugu.service';
import { ClientLoaderService } from '@shared/components/client-loader/client-loader.service';
import { TrackingService } from '@modules/client/services/tracking.service';
import { saveAs } from 'file-saver';
import { DialogPdfConfirmationDownload } from '@shared/components/dialog/template/dialog-pdf-confirmation-download/dialog-pdf-confirmation-download.component';
import { DataLayerService } from '@app/services/applyment/data-layer/data-layer.service';
import { LogDataLayerSendEventService } from '@app/services/applyment/data-layer/log-send-event/log-data-layer-send-event.service';
import { LogDataLayerSendEvent } from '@app/services/applyment/data-layer/log-send-event/log-data-layer-send-event';
import { DialogIframeRubeusPay } from '@shared/components/dialog/template/dialog-iframe-rubeus-pay/dialog-iframe-rubeus-pay.component';
import { QueryOptionsService } from '@app/services/applyment/query-options/query-options.service';

@Injectable()
export class FormioFunctions {

  mySubscription: any;
  stage: any;
  private dialogRefs: MatDialogRef<DialogComponent>[] = [];

  constructor(
    private ngZone: NgZone,
    public buttonActionsService: ButtonActionsService,
    private route: Router,
    private snackBar: MatSnackBar,
    private popUpApplymentService: PopUpApplymentService,
    private dialog: MatDialog,
    private getStepsService: GetStepsService,
    private applymentModel: ApplymentModel,
    private reportService: ReportService,
    public iuguService: IugoService,
    public dataLayerService: DataLayerService,
    public clientLoaderService: ClientLoaderService,
    public trackingService: TrackingService,
    public queryOptionsService: QueryOptionsService,
    public logDataLayerSendEvent: LogDataLayerSendEventService) {
    (window as any).formFunctions = this;
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.route.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.route.navigated = false;
      }
      if (event instanceof NavigationStart) {
        // Trick the Router into believing it's last link wasn't previously loaded
        if (event.navigationTrigger === 'popstate') {
          location.reload();
        }
      }
    });
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    console.log('Back button pressed');
  }

  public testValidatorsLogic(comp, input) {
    const obj = JSON.parse(JSON.stringify(comp.validatorData.data));
    const message = comp.validatorData.message.trim() === '' ? 'Campo inválido' : comp.validatorData.message;
    const result = true;
    return this.testInputValue(comp, message, result, JSON.parse(JSON.stringify(input)), obj);
  }

  public testMultivaluedMinValues(comp, input) {
    const data = comp.data.values;
    if (Array.isArray(data) && data.length >= comp.min_multivalued_options) {
      if (Array.isArray(input) && input.length < comp.min_multivalued_options) {
        return `Mínimo de ${comp.min_multivalued_options} opções selecionadas`
      }
    }
    return false;
  }

  public testInputMask(component, input, submission) {
    let message = null;
    if (Array.isArray(input)) {
      input.forEach(input => {
        if (input && input.search('_') !== -1) {
          message = 'A informação digitada no campo não é válida.';
        }
      });
    } else {
      if (input && input.search('_') !== -1) {
        message = 'A informação digitada no campo não é válida.';
      }
    }
    if (typeof message === 'string') {
      this.addErrorElement(component, message);
      submission.valid = false;
    }
  }

  public async getOptionsFromServer(datasource, target, relation_id, filter = [], nextFields = [], firstLoad = false): Promise<Array<any>> {
    return new Promise((resolve, reject) => {
      if (!firstLoad) {
        this.clientLoaderService.setLoadAvailability(false);
      }
      if (relation_id) {
        this.toogleLoader(relation_id);
      }
      this.queryOptionsService.create({datasource, target, filter, nextFields, token: localStorage.getItem('token')}).subscribe(
        (result) => {
          this.toogleLoader(relation_id);
          if (!firstLoad) {
            this.clientLoaderService.setLoadAvailability(true);
          }
          if (result.success) {
            resolve(result.data);
          } else {
            reject([]);
          }
        },
        () => {
          this.toogleLoader(relation_id);
          if (!firstLoad) {
            this.clientLoaderService.setLoadAvailability(true);
          }
          reject([])
        }
        )
    })
  }

  public testLogic(arg, localValue, form) {
    const operator = arg.operator;
    const ruleValue = arg.value;
    const testComponent = this.findComponentLogic(form.components, arg.key, false);
    const value = () => {
      let usedValue = null;
      if (typeof arg.systemValue === 'undefined'  || arg.systemValue === null) {} else {
        usedValue = arg.systemValue;
      }
      if (typeof localValue === 'undefined'  || localValue === null) {} else {
        usedValue = localValue;
      }
      return usedValue;
    };
    let result = null;
    if (value() === null && operator != 3) {
      result = null;
    } else {
      switch (operator) {
        case 1: // igual
          if (testComponent.type == 'datetime') {
              const valueDate = new Date(value());
              const ruleDate = new Date(ruleValue);
              if (!isNaN(valueDate.getTime()) && !isNaN(ruleDate.getTime())) {
                valueDate.setHours(0, 0, 0, 0);
                result = valueDate.getTime() === ruleDate.getTime();
              } else {
                result = null;
              }
          } else if(testComponent.type === 'selectboxes') {
            const [booleanValue] = Object.values(value())
            if (this.getBooleanRuleValue(ruleValue) === booleanValue) {
              result = true;
            } else {
              result = false;
            }
          } else if(testComponent.type === 'checkbox') {
            const booleanValue = String(value()) === '1' || value() ? true : false;
            if (this.getBooleanRuleValue(ruleValue) === booleanValue) {
              result = true;
            } else {
              result = false;
            }
          } else {
            if (value().toString().toLowerCase() === ruleValue.toString().toLowerCase()) {
              result = true;
            } else {
              result = false;
            }
          }
          break;
        case 2: // diferente
          if (testComponent.type == 'datetime') {
            const valueDate = new Date(value());
            const ruleDate = new Date(ruleValue);
            if (!isNaN(valueDate.getTime()) && !isNaN(ruleDate.getTime())) {
              valueDate.setHours(0, 0, 0, 0);
              result = valueDate.getTime() !== ruleDate.getTime();
            } else {
              result = null;
            }
          } else if(testComponent.type === 'selectboxes') {
            const [booleanValue] = Object.values(value())
            if (this.getBooleanRuleValue(ruleValue) !== booleanValue) {
              result = true;
            } else {
              result = false;
            }
          } else if(testComponent.type === 'checkbox') {
            const booleanValue = String(value()) === '1' || value() ? true : false;
            if (this.getBooleanRuleValue(ruleValue) !== booleanValue) {
              result = true;
            } else {
              result = false;
            }
          } else {
            if (value().toString().toLowerCase() !== ruleValue.toString().toLowerCase() ) {
              result = true;
            } else {
              result = false;
            }
          }
          break;
        case 3: // não existe
          if(testComponent.type === 'selectboxes') {
            const [booleanValue] = Object.values(value())
            if (this.getBooleanRuleValue(ruleValue) !== booleanValue) {
              result = true;
            } else {
              result = false;
            }
          } else if(testComponent.type === 'checkbox') {
            const booleanValue = String(value()) === '1' || value() ? true : false;
            if (this.getBooleanRuleValue(ruleValue) !== booleanValue) {
              result = true;
            } else {
              result = false;
            }
          } else {
            if (value().toString().toLowerCase().trim() === '') {
              result = true;
            } else {
              result = false;
            }
          }
          break;
        case 4: // existe
          if(testComponent.type === 'selectboxes') {
            const [booleanValue] = Object.values(value())
            if (this.getBooleanRuleValue(ruleValue) === booleanValue) {
              result = true;
            } else {
              result = false;
            }
          } else if(testComponent.type === 'checkbox') {
            const booleanValue = String(value()) === '1' || value() ? true : false;
            if (this.getBooleanRuleValue(ruleValue) === booleanValue) {
              result = true;
            } else {
              result = false;
            }
          } else {
            if (value().toString().toLowerCase().trim() !== '') {
              result = true;
            } else {
              result = false;
            }
          }
          break;
        case 5: // maior
          if (testComponent.type == 'datetime') {
            const valueDate = new Date(value());
            const ruleDate = new Date(ruleValue);
            if (!isNaN(valueDate.getTime()) && !isNaN(ruleDate.getTime())) {
              valueDate.setHours(0, 0, 0, 0);
              result = valueDate.getTime() > ruleDate.getTime();
            } else {
              result = null;
            }
          } else {
            if ( !isNaN(Number(value().toString().toLowerCase())) && !isNaN(Number(ruleValue.toString().toLowerCase()))  ) {
              result = Number(value().toString().toLowerCase()) > Number(ruleValue.toString().toLowerCase());
            } else {
              result = null;
            }
          }
          break;
        case 6: // menor
          if (testComponent.type == 'datetime') {
            const valueDate = new Date(value());
            const ruleDate = new Date(ruleValue);
            if (!isNaN(valueDate.getTime()) && !isNaN(ruleDate.getTime())) {
              valueDate.setHours(0, 0, 0, 0);
              result = valueDate.getTime() < ruleDate.getTime();
            } else {
              result = null;
            }
          } else {
            if ( !isNaN(Number(value().toString().toLowerCase())) && !isNaN(Number(ruleValue.toString().toLowerCase()))  ) {
              result = Number(value().toString().toLowerCase()) < Number(ruleValue.toString().toLowerCase());
            } else {
              result = null;
            }
          }
          break;
        case 7: // contem
        if (testComponent.type == 'datetime') {
          const valueDate = new Date(value());
          const ruleDate = new Date(ruleValue);
          if (!isNaN(valueDate.getTime()) && !isNaN(ruleDate.getTime())) {
            valueDate.setHours(0, 0, 0, 0);
            result = valueDate.getTime() === ruleDate.getTime();
          } else {
            result = null;
          }
        } else if(testComponent.type === 'selectboxes') {
          const [booleanValue] = Object.values(value())
          if (this.getBooleanRuleValue(ruleValue) === booleanValue) {
            result = true;
          } else {
            result = false;
          }
        } else if(testComponent.type === 'checkbox') {
          const booleanValue = String(value()) === '1' || value() ? true : false;
          if (this.getBooleanRuleValue(ruleValue) === booleanValue) {
            result = true;
          } else {
            result = false;
          }
        } else {
          if (value().toString().toLowerCase().includes(ruleValue.toString().toLowerCase())) {
            result = true;
          } else {
            result = false;
          }
        }
        break;
        case 8: // não contem
        if (testComponent.type == 'datetime') {
          const valueDate = new Date(value());
          const ruleDate = new Date(ruleValue);
          if (!isNaN(valueDate.getTime()) && !isNaN(ruleDate.getTime())) {
            valueDate.setHours(0, 0, 0, 0);
            result = valueDate.getTime() !== ruleDate.getTime();
          } else {
            result = null;
          }
        } else if(testComponent.type === 'selectboxes') {
          const [booleanValue] = Object.values(value())
          if (this.getBooleanRuleValue(ruleValue) !== booleanValue) {
            result = true;
          } else {
            result = false;
          }
        } else if(testComponent.type === 'checkbox') {
          const booleanValue = String(value()) === '1' || value() ? true : false;
          if (this.getBooleanRuleValue(ruleValue) !== booleanValue) {
            result = true;
          } else {
            result = false;
          }
        } else {
          if ( !(value().toString().toLowerCase().includes(ruleValue.toString().toLowerCase())) ) {
            result = true;
          } else {
            result = false;
          }
        }
        break;
      default:
        result = null;
        break;
      }
    }
    return result;
  }

  private getBooleanRuleValue(rule) {
    if (rule === 'false') {
      return false;
    }

    return Boolean(rule);
  }

  public checkLogicTestsResults(resultArray, condition, action) {
    let result = null;
    if (condition === 1 && resultArray.length > 0) {
      result = false;
      resultArray.map( (elem) => {
        if (elem === true) {
          result = true;
        }
      });
    }
    if (condition === 2 && resultArray.length > 0) {
      result = true;
      resultArray.map( (elem) => {
        if (elem === false) {
          result = false;
        }
      });
    }
    if (action === 1) {
      if (result === true) {
        return true;
      } else if (result === false) {
        return false;
      } else if (result !== null) {
        return true;
      }
    } else if (action === 2) {
      if (result === true) {
        return false;
      } else if (result === false) {
        return true;
      } else if (result !== null) {
        return false;
      }
    }
  }

  public submit(data, comp, form) {
    data.formatedData = [];
    if (comp.live === true) {
      data.valid = true;
      Object.keys(data).forEach((val) => {
        const component = this.findComponent(form.components, val, false);
        if (component) {
          this.removeErrorElement(component)
          const componentData = component.component?? component;
          if (componentData.type === "email" && data[val] !== '') {
            this.validadeEmailComponentValue(component, data[val], data);
          }
          if (componentData.validatorData !== undefined && componentData.validatorData.enable == true && comp.store_data) {
            this.validateSubmissionValues(component, data[val], data);
          }
          if (componentData.multivalued && componentData.min_multivalued_options > 0) {
            this.validateMinValues(component, data[val], data);
          }
          if (componentData.inputMask && componentData.inputMask !== '' ) {
              this.testInputMask(component, data[val], data);
          }
          if (componentData.type === "lgpd") {
            if (componentData.lgpd_content.consent_id === 3) {
              data[val] = this.legitConsentSendSignatures(componentData);
            } else {
              this.validadeLgpdComponentValue(component, data[val], data);
            }
          }
          if (component.defaultMask) {
            component.defaultMask.forEach(element => {
              if (typeof element === 'string') {
                if (Array.isArray(data[val])) {
                  data[val].forEach(val => {
                    val = val.replace(element, '');
                  });
                } else {
                  data[val] = data[val].replace(element, '');
                }
              }
            });
          }
          if (component.type === 'selectboxes') {
            const values = component.getValue();
            const values_to_submit = [];
            Object.keys(values).forEach( key => {
              if (values[key] === true) {
                values_to_submit.push(key);
              }
            })
            data[val] = values_to_submit;
          }
          if (component.type === 'datetime') {
            if (data[val].indexOf('T') !== -1) {
              data[val] = data[val].substr(0, data[val].indexOf('T'));
            }
          }
          if (data[val] !== null) {
            const type = componentData.type;
            if (type !== 'button') {

              const formatedData: any = {
                field_id: null,
                component_id: null,
                key: componentData.key,
                value: this.getFieldValueTrimmed(data[val]),
                rubeus_table: componentData.rubeus_table,
                ps_table: componentData.ps_table,
                type: componentData.type
              }

              if (componentData.field_id !== undefined && componentData.field_id !== null) {
                formatedData.field_id = componentData.field_id;
              } else {
                formatedData.component_id = componentData.id;
              }

              if (componentData.field_id_related_to_component !== undefined) {
                formatedData.field_id = componentData.field_id_related_to_component;
              }

              if (componentData.field_id_to_save_cep !== undefined) {
                formatedData.field_id = componentData.field_id_to_save_cep;
              }
              if (component && component.visible && component.parentVisible) {
                data.formatedData.push(
                  formatedData
                );
              }

            }
          }
        }
      });
      if (data.valid === true && comp.store_data) {
        this.executeAction(data, comp, form);
      } else if (!comp.store_data) {
        this.executeAction(data, comp, form);
      }
    }
  }

  private getFieldValueTrimmed(value) {
    if (typeof value === 'string') {
      return value.trim();
    }
    return value
  }

  private validateMinValues (component, input, submission) {
    const componentData = component.component?? component;
    const message = this.testMultivaluedMinValues(componentData, input);
    if (typeof message === 'string') {
      this.addErrorElement(component, message);
      submission.valid = false;
    }
  }

  private validadeEmailComponentValue (component, input, submission) {
    const message = this.testEmailPatternValue(input);
    if (typeof message === 'string') {
      this.addErrorElement(component, message);
      submission.valid = false;
    }
  }

  private testEmailPatternValue(value = '') {
    const regexValidate = '/^(([0-9a-zA-Z]+[-._+&])*[-.+&0-9a-zA-Z_]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,10}){0,1}$/';
    let regexResult = true;

    try {
      regexResult = eval(`${regexValidate}.test("${value}")`);
    } catch {}

    if (!regexResult) {
      return 'O e-mail informado não é válido.';
    }

    return false;
  }

  private legitConsentSendSignatures(component) {
    const data = [];
    if (Array.isArray(component.lgpd_content.signatures)) {
      component.lgpd_content.signatures.map((signature) => {
        data.push(
          {field: signature.field_id_to_save_signature, status: '1'}
        )
      });
    }
    return data;
  }

  private validadeLgpdComponentValue (component, input, submission) {
    const componentData = component.component?? component;
    const message = this.testLgpdSignatures(componentData, input);
    if (typeof message === 'string') {
      this.addErrorElement(component, message);
      submission.valid = false;
    }
  }

  public testLgpdSignatures(componentData, input) {
    const lgpd_content = componentData.lgpd_content;
    const signatures = lgpd_content.signatures
    let message: any = false;
    signatures.map((signature) => {
      const signatureInput = input.filter(val => val.field === signature.field_id_to_save_signature)[0];
      if (signatureInput) {
        if (signature.required && signatureInput.status == '2') {
          message = 'É preciso marcar todas as caixas obrigatórias!';
        }
      } else {
        if (signature.required) {
          message = 'É preciso marcar todas as caixas obrigatórias!';
        }
      }
    });
    if (lgpd_content.consent_id === 2) {
      const consentProcessInput = input.filter(val => val.field === lgpd_content.field_id_to_save_consent_process)[0];
      if (consentProcessInput) {
        if (consentProcessInput.status == '2') {
          message = 'É preciso marcar todas as caixas obrigatórias!';
        }
      } else {
        message = 'É preciso marcar todas as caixas obrigatórias!';
      }
    }
    return message;
  }

  private validateSubmissionValues (component, input, submission) {
      const componentData = component.component?? component;
      const message = this.testValidatorsLogic(componentData, input);
      if (typeof message === 'string') {
        this.addErrorElement(component, message);
        submission.valid = false;
      }
  }

  private addErrorElement(component, message) {
    let errorElement = document.getElementById('ps-error-'+component.id);
    if (errorElement) {
      errorElement.appendChild(this.createErrorText(message));
    } else {
      const parentElement = document.getElementById(component.id);
      errorElement = document.createElement('div');
      errorElement.setAttribute('id', 'ps-error-'+component.id);
      errorElement.setAttribute('class', 'ps-custom-error-element');
      errorElement.appendChild(this.createErrorText(message));
      parentElement.appendChild(errorElement);
    }
  }

  createErrorText(message) {
    const errorTextElement = document.createElement('div');
    errorTextElement.setAttribute('class', 'ps-error-text');
    errorTextElement.setAttribute('style', 'padding:1px;');
    errorTextElement.innerText = message
    return errorTextElement;
  }

  private removeErrorElement(component) {
    const errorElement = document.getElementById('ps-error-'+component.id);
    if (errorElement) {
      const parentElement = document.getElementById(component.id);
      parentElement.removeChild(errorElement);
    }
  }

  private async executeAction(data, comp, form) {
    const token = localStorage.getItem('token');

    if (!token) {
      location.reload();
    }

    const trackingLoaded = this.trackingService.checkTrackingAvailability();
    if (!trackingLoaded || (trackingLoaded && !localStorage.getItem('hostClient_tracking_' + token))) {
      this.trackingService.loadTrackingScript();

      await new Promise(r => setTimeout(r, 1000));
    }

    const trackingData = this.trackingService.getTrackingInfo();

    const submissionData: any = {
        stage_id: this.stage ?? null,
        selective_process_id: this.applymentModel.getSettings().selective_process_id ?? null,
        domainParams: this.applymentModel.getSettings().domainParams ?? null,
        last_place_id: localStorage.getItem('last_place_id') ?? null,
        last_place_type_id: localStorage.getItem('last_place_type_id') ?? null,
        button_id: comp.id,
        related_component_id: comp?.related_component_id,
        data: data.formatedData,
        rbParams: comp?.rbParams ? [comp?.rbParams] : null,
        token: localStorage.getItem('token'),
        substitute_id : trackingData['substitute_id'],
        session_id : trackingData['session_id'],
        hostClient : trackingData['host_client'],
        contact_id_crm : trackingData['contact_crm']
    };
    if(comp.lgpdDataFromPopUp) {
      submissionData.lgpd_person_id = comp.lgpdDataFromPopUp.person_id;
      submissionData.lgpd_applyment_id = comp.lgpdDataFromPopUp.applyment_id;
    }

    if(comp.previousSubmissionDataFromPopUp) {
      submissionData.previousSubmissionDataFromPopUp = [...comp.previousSubmissionDataFromPopUp] ;
    }

    this.ngZone.run(async () => {
      const fieldsCheckIuguAfya:{ button_id, related_component_id } = {
        button_id: submissionData.button_id,
        related_component_id: submissionData.related_component_id
      }

      const checkIfExecuteIuguActions = this.iuguService.isPaymentButtonAfya(fieldsCheckIuguAfya);
      if(!checkIfExecuteIuguActions) {
        this.executeButtonActions(submissionData,form);
      } else {
        this.clientLoaderService.setChangesLoaderState(true);
        this.iuguService.setScriptIntoHtml();

        const payIuguResult = await this.executeIuguActions(submissionData);

        this.clientLoaderService.setChangesLoaderState(false);
        if (payIuguResult?.success) {
          payIuguResult.data.isIugu = true;
          if(payIuguResult.data?.report) {
            this.openReport(payIuguResult.data, submissionData);
          }

          this.executeButtonActions(submissionData,form);
        } else {
          this.openErrorNotificationComponent(payIuguResult?.data?.message || "Ocorreu um erro");
        }
      }
    });
  }

  async executeIuguActions(submissionData) {
    try {
      return await this.iuguService.execute(submissionData);
    } catch (error) {
      return {
        success: false,
        data: {
          message: 'Ocorreu um erro ao realizar o pagamento',
          errors: error.message
        }
      }
    }
  }

  executeButtonActions(submissionData, form):any {
    this.buttonActionsService.postApplymentDataWithFormData(submissionData).pipe(
      filterResponse()
    ).subscribe((res: any) => {
      if (res.success) {
          if (res.data.upload) {
            this.addUploadErrors(res.data.upload, form);
            this.openErrorNotificationComponent('Erro no envio dos arquivos');
          } else {
            if (res.data.close_popup) {
              if ((window as any).psClosePopUp) {
                (window as any).psClosePopUp();
              }
            }

            if (res.data.report) {
              this.openReport(res.data, submissionData);
            } else if(res.data.rubeus_pay_integration) {
              this.openRubeusPay(res.data, submissionData);
            } else {
              this.redirect(res.data, submissionData);
            }

            if (res.data.data_layer_objects && res.data.data_layer_objects.length > 0) {
              const logDataLayer: LogDataLayerSendEvent = {
                data_layer_objects: res.data.data_layer_objects ?? null,
                button_id: submissionData.button_id,
                person_id: res.data?.person_id ?? null,
                selective_process_id: submissionData.selective_process_id,
                stage_id: res.data?.stage_id ?? (submissionData.stage_id ?? null),
                last_place_id: submissionData.last_place_id,
                last_place_type_id: submissionData.last_place_type_id
              }

              this.dataLayerService.pushManyToDataLayer(res.data.data_layer_objects);
              this.logDataLayerSendEvent.create(logDataLayer).subscribe();
            }
          }
          if (res.data.pushToDataLayer) {
            this.dataLayerService = new DataLayerService();
            this.dataLayerService.pushToDataLayer(res.data.dataLayerObject);
          }
      } else {
        let msg = '';
        if (typeof res.data === 'string') {
          msg = res.data;
        } else {
          msg = res.data.msg
        }
        if (res.data.upload) {
          this.addUploadErrors(res.data.upload, form);
        }
        this.openErrorNotificationComponent(msg);
      }
    },
      (err: any) => {
        if (err.error) {
          const error = err.error;
          if (error.data) {
            if (error.data.session_error) {
              this.openErrorNotificationComponent('É necessário iniciar sua inscrição novamente!', 'Sua sessão expirou', 'alert');
              if ((window as any).psClosePopUp) {
                (window as any).psClosePopUp();
              }
              if (error.data.link) {
                this.route.navigate([error.data.link]);
              }
            }
          }
        }
      }
    );
  }

  private reloadCurrentRoute(submissionData) {
    if ((window as any).psClosePopUp) {
      (window as any).psClosePopUp();
    }

    const previousSubmissionData = this.getPreviousSubmissionData(submissionData);
    const currentUrl = this.route.url;

    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.route.navigate([currentUrl], { state: { previousSubmissionData } });
    });
  }

  private getPreviousSubmissionData(submissionData) {
    const previousSubmissionData = [...submissionData.data];

    if (submissionData?.previousSubmissionDataFromPopUp) {
      const previousData = [...submissionData.previousSubmissionDataFromPopUp];

      previousData.forEach(previewField => {
        if (previewField.value) {
          const field = previousSubmissionData.find(e => e.key === previewField.key);

          if (!field) {
            previousSubmissionData.push(previewField);
          } else {
            if (!field.value) {
              field.value = previewField.value;
            }
          }
        }
      });
    }

    return previousSubmissionData;
  }

  openErrorNotificationComponent(msg, title = 'Atenção!', type = 'error', duration = 5000) {
    this.snackBar.openFromComponent(NotificationComponent, {
      panelClass: type,
      duration,
      data: {
        title: title,
        msg: msg,
        act: 'OK',
        type: type
      }
    });
  }

  showNotificationComponent(msg:string, title:string = 'Atenção!', type:string = 'error', duration:number = 5000) {
    this.ngZone.run(() => {
      this.openErrorNotificationComponent(msg, title, type, duration);
    });
  }

  private addUploadErrors(upload, form) {
    const uploadElement = this.findComponent(form.components, upload.component_id, false, true);
    if (uploadElement) {
      const files = this.getSelectedFiles(uploadElement.inputs);
      upload.errors.map((errorObject) => {
        const fileIndex = errorObject.file_name.split('_')[1];
        const wrongFile = files[fileIndex];
        if (wrongFile) {
          wrongFile.file.error = errorObject.error;

          const error_message = document.createElement('div');
          error_message.innerText = errorObject.error;
          error_message.id = `error-${wrongFile.inputIndex}-${wrongFile.fileIndex}`;
          error_message.setAttribute('class', 'ps-error-text file-error');

          const selectedFileList = document.getElementById(`${uploadElement.component.key}-selectedFilesList-${wrongFile.inputIndex}`)
          this.removeOldAndPutUploadErrorMessage(selectedFileList, wrongFile, error_message)
        }
      });
    }
  }

  removeOldAndPutUploadErrorMessage(selectedFileList, wrongFile, error_message) {
    for (let index = 0; index < selectedFileList.children.length; index++) {
      const element = selectedFileList.children[index];
      if (element.id === `error-${wrongFile.inputIndex}-${wrongFile.fileIndex}`) {
        selectedFileList.removeChild(element);
      }
    }

    for (let index = 0; index < selectedFileList.children.length; index++) {
      const chip = selectedFileList.children[index];
      if (chip.id === `ps-file-chip-${wrongFile.inputIndex}-${wrongFile.fileIndex}`) {
        chip.insertAdjacentElement('afterend', error_message);
      }
    }
  }

  getSelectedFiles(inputs) {
    const files = []
    inputs.map((input, inputIndex)=> {
      if (input.files && input.files.length > 0) {
        input.files.map((file, fileIndex) => {
          files.push({file, fileIndex, inputIndex});
        });
      }
    });
    return files;
  }

  public openReport(data, submissionData) {
    const isIugu = data?.isIugu || false;
    let url = '';

    if(isIugu) {
      url = data.report.url;
    } else {
      url = this.reportService.showReport(data.report.access_report);
    }
    switch (data.report.report_view_id) {
      case 1://mesma aba
        this.dialog.open(DialogComponent, {
          maxWidth: '100%',
          height: '100%',
          width: 'inherit',
          data: {
            component: DialogPdfViewer,
            contentDialogClassName: 'ps-dialog-icon-chose-content',
            data: {
              url
            }
          },
          autoFocus: false
        }).afterClosed().subscribe(() => {
          this.calRedirectAfterReport(data, submissionData, isIugu);
        });

        break;
      case 2:// nova aba
        if(isIOSDevice()) {
          const dialog = this.openReportIphone(url);

          dialog.afterClosed().subscribe(() => {
            this.calRedirectAfterReport(data, submissionData, isIugu);
          });
        } else {
          this.openLink(url,'_blank');
          this.calRedirectAfterReport(data, submissionData, isIugu);
        }

        break;
      case 3:// download
        if(isIOSDevice()) {
          const dialog = this.openReportIphone(url);

          dialog.afterClosed().subscribe(() => {
            this.calRedirectAfterReport(data, submissionData, isIugu);
          });
        } else {
          saveAs(url);
          this.calRedirectAfterReport(data, submissionData, isIugu);
        }

        break;
      case 4:
        this.calRedirectAfterReport(data, submissionData, isIugu);
        break;
    }
  }

  private calRedirectAfterReport(data, submissionData, isIugu) {
    if(!isIugu){
      this.redirect(data, submissionData)
    }
  }

  private openReportIphone(url: string) {
    const dialog =  this.dialog.open(DialogComponent, {
      maxWidth: '500px',
      width: 'inherit',
      data: {
        component: DialogPdfConfirmationDownload,
        contentDialogClassName: 'ps-dialog-config',
        data: {
          url
        }
      },
      autoFocus: false
    });

    return dialog;
  }

  private openLink(link: string, target: any = false) {
    const a = document.createElement("a");
    a.href = link;

    if (target) {
      a.target = target;
    }

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  private redirect(data, submissionData) {
    if (this.needExecuteStageQuery(data.stage_id)) {
      this.getStepsService.data.execute_stage_query = 1;
    } else {
      this.getStepsService.data.execute_stage_query = 0;
    } 

    this.stage = data.stage_id;

    if(data.same_place) {
      this.reloadCurrentRoute(submissionData);
    } else {
      switch (data.place_type_id) {
        case 1:
            this.redirectToStep(data.link, data.place_id);
          break;
        case 2:
          this.redirectToFeedback(data.link, data.place_id);
          break;
        case 3:
          this.redirectToExternalLink(data.link, data.new_tab);
          break;
        case 4:
          this.redirectToPage(data.link, data.place_id, data.selective_process_id, data);
          break;
        case 5:
          this.redirectToPortal(data.link);
          break;
        case 6:
          this.redirectToPopUp(data, submissionData);
          break;
        case 7:
          this.redirectToProcessSelection();
        default:
          break;
        }
    }
  }

  private needExecuteStageQuery(stage_id) {
    if (!this.stage) {
      return true;
    }
    return this.stage !== stage_id;
  }

  private redirectToProcessSelection(){
    this.route.navigate([this.applymentModel.getSettings().domainParams]);
  }

  private redirectToPopUp(data, submissionData) {
    const token = localStorage.getItem('token');

    const trackingData = this.trackingService.getTrackingInfo();

    const date = {
      popup_id: data.place_id,
      stage: {stage_id: data.stage_id},
      token: localStorage.getItem('token'),
      substitute_id : trackingData['substitute_id'],
      session_id : trackingData['session_id'],
      hostClient : trackingData['host_client'],
      contact_id_crm : trackingData['contact_crm']
    };
    this.popUpApplymentService.create(date).subscribe((res) => {
      if ( res.success ) {
        const dialog =  this.dialog.open(DialogComponent, {
          maxWidth: res.data.maximum_width + 'px',
          maxHeight: res.data.maximum_height + 'px',
          width: 'inherit',
          disableClose: !res.data.allow_close_popup,
          // minWidth: '200px',
          data: {
            component: DialogPopupFormComponent,
            contentDialogClassName: 'ps-dialog-form-popup-content',
            closeButton: res.data.allow_close_popup,
            data:  {...res.data, previousSubmissionData: submissionData.data}
          },
          autoFocus: false
        });
        this.dialogRefs.push(dialog);
      } else {
        this.openErrorNotificationComponent(res.data);
      }

    },
    error => {
      this.openErrorNotificationComponent(error.data);
    }
    );
  }

  private redirectToPage(link, page_id, selective_process_id, data) : void {
    this.closeDialogs();
    this.route.navigate([link + '/processo', selective_process_id, 'pagina', page_id], {queryParamsHandling: 'preserve', state: { stage_id: data.stage_id }});
  }

  private redirectToPortal(link): void {
    this.closeDialogs();
    this.route.navigate([link + '/portal-inscrito'], {queryParamsHandling: 'preserve'});
  }

  private closeDialogs(): void {  
    this.dialogRefs.forEach((dialog: MatDialogRef<DialogComponent>) => dialog?.close());
    this.dialogRefs = [];
  }

  private redirectToStep(link, step_id) : void {
    this.closeDialogs();
    localStorage.setItem('last_place_id', step_id);
    localStorage.setItem('last_place_type_id', "1");
    this.route.navigate([link + '/passo', step_id], {queryParamsHandling: 'preserve'});
  }

  private redirectToFeedback(link, feedback_id) : void {
    this.closeDialogs();
    localStorage.setItem('last_place_id', feedback_id);
    localStorage.setItem('last_place_type_id', "2");
    this.route.navigate([link + '/feedback', feedback_id], {queryParamsHandling: 'preserve'});
  }

  private redirectToExternalLink(link, new_tab): void {
    if (new_tab === 1) {
      window.open(link, '_blank');
    } else {
      window.open(link, '_top');
    }
  }

  private columnArrayMerge(columns) {
    const column = [];
    columns.map(item => {
      if (item.length > 0) {
        item.map(i => {
          column.push(i);
        });
      }
    });
    return column;
  }

  private columnArrayMergeLogic(columns) {
    const column = [];
    columns.map(item => {
      if (item.components.length > 0) {
        item.components.map(i => {
          column.push(i);
        });
      }
    });
    return column;
  }

  private findComponentLogic(components, val, item: any) {
    components.map(comp => {
      const componentData = comp.component?? comp;
      if (Utils.isLayoutComponent(comp)) {
        if (componentData.type === 'columns') {
          const columns = this.columnArrayMergeLogic(comp.columns);
          if (columns.length > 0) {
            item = this.findComponentLogic(columns, val, item);
            return;
          }
        }
        if (componentData.type === 'fieldset') {
          item = this.findComponent(comp.components, val, item);
          return;
        }
      } else {
        if (componentData.key == val) {
          item = comp;
          return;
        }
      }
    });
    return item;
  }

  private findComponent(components, val, item: any, searchViaId?) {
    components.map(comp => {
      const componentData = comp.component?? comp;
      if (Utils.isLayoutComponent(comp)) {
        if (componentData.type === 'columns') {
          const columns = this.columnArrayMerge(comp.columns);
          if (columns.length > 0) {
            item = this.findComponent(columns, val, item, searchViaId);
            return;
          }
        }
        if (componentData.type === 'fieldset') {
          item = this.findComponent(comp.components, val, item, searchViaId);
          return;
        }
      } else {
        if (searchViaId) {
          if (componentData && componentData.id == val) {
            item = comp;
            return;
          } else if (componentData.id == val) {
            item = comp;
            return;
          }
        }
        if (componentData && componentData.key == val) {
          item = comp;
          return;
        } else if (componentData.key == val) {
          item = comp;
          return;
        }
      }
    });
    return item;
  }

  testInputValue(comp, message, result, input, obj) {
    const inputValues = Array.isArray(input) ? [...input] : [input];

    if (inputValues.length === 0) {
      inputValues.push('');
    }

    inputValues.forEach(inputValue => {
      obj.forEach(validator => {
        switch (validator.key) {
          case 'required':
            if (comp.type === 'checkbox') {
              if (validator.value && (inputValue == false || inputValue == 0 || inputValue == "0")) {
                result = false;
                message = validator.customMessage ? validator.customMessage : message;
                return;
              }
            } else {
              if (validator.value && (inputValue === "" || inputValue === null)) {
                result = false;
                message = validator.customMessage ? validator.customMessage : message;
                return;
              }
            }
            break;
          case 'requiredNumber':
            if (validator.value && (inputValue === null || isNaN(inputValue) || inputValue === "")) {
              result = false;
              message = validator.customMessage ? validator.customMessage : message;
              return;
            }
            break;
          case 'requiredCheck':
            if (comp.type === 'checkbox') {
              if (validator.value && (inputValue == false || inputValue == 0 || inputValue == "0")) {
                result = false;
                message = validator.customMessage ? validator.customMessage : message;
                return;
              }
            } else {
              if (validator.value && (!Object.values(inputValue).includes(true))) {
                result = false;
                message = validator.customMessage ? validator.customMessage : message;
                return;
              }
            }
            break;
          case 'min':
            if (inputValue < validator.value) {
              result = false;
              message = validator.customMessage ? validator.customMessage : message;
              return;
            }
            break;
          case 'max':
            if (inputValue > validator.value) {
              result = false;
              message = validator.customMessage ? validator.customMessage : message;
              return;
            }
            break;
          case 'minLength':
            if (typeof inputValue === 'string' && inputValue.trim().length < validator.value) {
              result = false;
              message = validator.customMessage ? validator.customMessage : message;
              return;
            }
            break;
          case 'maxLength':
            if (typeof inputValue === 'string' && inputValue.trim().length > validator.value) {
              result = false;
              message = validator.customMessage ? validator.customMessage : message;
              return;
            }
            break;
          case 'minWords':
            if (typeof inputValue === 'string' && inputValue.trim().split(' ').length < validator.value) {
              result = false;
              message = validator.customMessage ? validator.customMessage : message;
              return;
            }
            break;
          case 'maxWords':
            if (typeof inputValue === 'string' && inputValue.trim().split(' ').length > validator.value) {
              result = false;
              message = validator.customMessage ? validator.customMessage : message;
              return;
            }
            break;
          case 'pattern':
            if (validator.value !== '') {
              if (!validator.reverse) {
                // tslint:disable: no-eval
                let regexResult = true;
                try {
                  regexResult = eval(`${validator.value}.test("${inputValue}")`);
                } catch {}
                if (regexResult) {} else {
                  result = false;
                  message = validator.customMessage ? validator.customMessage : message;
                  return;
                }
              } else {
                let regexResult = true;
                try {
                  regexResult = !eval(`${validator.value}.test("${inputValue}")`);
                } catch {}
                if (regexResult) {} else {
                  result = false;
                  message = validator.customMessage ? validator.customMessage : message;
                  return;
                }
              }
            }
            break;
          case 'cpf':
            if(inputValue != '') {
              if (!isValidCPF(inputValue)) {
                result = false;
                message = validator.customMessage ? validator.customMessage : message;
                return;
              }
            }
          break;
          case 'custom':
            let customFunction = () => undefined;
            try {
              customFunction = eval( '() => {' + validator.value + '}');
            } catch {}
            const customResult = customFunction();
            if (typeof customResult === 'string') {
              result = false;
              message = customResult;
            }
            break;
        }
      });
    });

    if (result) {
      return true;
    } else {
      return message;
    }
  }

  public openRubeusPay(data, submissionData) {
    const url = data.rubeus_pay_integration.url_rubeus_pay;

    switch (data.rubeus_pay_integration.open_rubeus_pays) {
      case '1'://mesma aba
        const dialog =  this.dialog.open(DialogComponent, {
          maxWidth: '90%',
          height: '90%',
          width: 'inherit',
          data: {
            component: DialogIframeRubeusPay,
            contentDialogClassName: 'ps-dialog-icon-chose-content',
            data: {
              url
            }
          },
          autoFocus: false
        });
        dialog.afterClosed().subscribe(() => {
          this.redirect(data, submissionData)
        });
        break;
      case '2':// nova aba
        if(isIOSDevice()) {
          const dialog = this.openRubeusPayIphone(url);

          dialog.afterClosed().subscribe(() => {
            this.redirect(data, submissionData)
          });
        } else {
          this.openLink(url,'_blank');
          this.redirect(data, submissionData)
        }
        break;
    }
  }

  private openRubeusPayIphone(url: string) {
    const dialog =  this.dialog.open(DialogComponent, {
      maxWidth: '500px',
      width: 'inherit',
      data: {
        component: DialogIframeRubeusPay,
        contentDialogClassName: 'ps-dialog-config',
        data: {
          url
        }
      },
      autoFocus: false
    });

    return dialog;
  }

  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }

  public toogleLoader(relation_id) {
    const selects = document.getElementsByName(relation_id);
    if (selects && selects.length > 0) {
      for (let index = 0; index < selects.length; index++) {
        const select = selects[index];
        select.classList.toggle('ps-auto-complete-loader-activated')
      }
    }
  }

}
